import React, { createContext, useContext } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => (
  <UserContext.Provider value={{ tableauInitiales: [], loading: false, error: null }}>
    {children}
  </UserContext.Provider>
);

export const useUserContext = () => useContext(UserContext);
